<div class="container-fluid">
  <page-header-search
    [isSearchInput]="true"
    [pageTitleValue]="pageTitle"
    [placeholderValue]="placeholder"
    (onHeaderInputKeyup)="onSearchInputKeyup($event)"
    (onHeaderSearchSubmit)="onSearchTest($event)"
  ></page-header-search>

  <div class="card">
    <div class="card-header border-0">
      <div class="row">
        <div class="col-6">
          <h3 class="mb-0">Tests</h3>
        </div>

        <div class="col-6 text-right">
          <a
            class="btn btn-sm btn-success btn-round btn-icon"
            (click)="SaveTests()"
            href="javascript:void(0)"
            tooltip="save tests"
            placement="top"
          >
            <span class="btn-inner--icon">
              <i class="ni ni-check-bold"> </i>
            </span>

            <span class="btn-inner--text"> Save </span>
          </a>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table align-items-center table-flush table-hover">
        <thead class="thead-light">
          <tr>
            <th>
              <div class="custom-control custom-checkbox">
                <input
                  class="custom-control-input"
                  id="table-check-all"
                  name="check-all"
                  [(ngModel)]="checkAll"
                  type="checkbox"
                  (change)="onCheckAll()"
                />

                <label class="custom-control-label" for="table-check-all">
                </label>
              </div>
            </th>

            <th>Test Name</th>

            <th>Price</th>
            <th>LCA Price</th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let test of filteredTests.tests"
            [class]="
              test.isChecked && test.price >= 0
                ? 'table-success'
                : 'table-danger'
            "
          >
            <th>
              <div class="custom-control custom-checkbox">
                <input
                  class="custom-control-input"
                  [id]="'table-check' + test.id"
                  type="checkbox"
                  [(ngModel)]="test.isChecked"
                />

                <label
                  class="custom-control-label"
                  [for]="'table-check' + test.id"
                >
                </label>
              </div>
            </th>

            <td class="table-user">
              <b> {{ test.name }}</b>
            </td>

            <td>
              <input
                [(ngModel)]="test.price"
                type="number"
                min="0"
                class="special text-muted"
              />
            </td>

            <td>
              <input
                [(ngModel)]="test.lcaPrice"
                type="number"
                min="0"
                class="special text-muted"
              />
            </td>

            <!-- <td>
              <a class=" font-weight-bold" href="javascript:void(0)">
                Argon Dashboard PRO
              </a>
            </td>

            <td>
              <label class=" custom-toggle">
                <input checked="checked" type="checkbox" />

                <span class=" custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes">
                </span>
              </label>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ngx-spinner></ngx-spinner>
